import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { User } from './cliente-visualizar-usuario.model';
const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root',
})
export class MasterClienteVisualizarUsuarioService {
  constructor(private httpClient: HttpClient) {}

  getUserByUserId(userId?: string, payload?: any): Observable<any> {
    if (userId === null || userId === undefined) {
      return throwError('Required parameter userId was null or undefined.');
    }

    return this.httpClient
      .post<any>(`${BASE_PATH}/bff/users/view/`, { id: userId })
      .pipe(retry(5), catchError(null));
  }
}
